export const PAGE_TYPES = {
  PRODUCT: "product",
  CATEGORY: "category",
  HOMEPAGE: "homepage",
  GENERAL: "general",
  BASKET: "basket",
  BLOG: "blog",
  SEARCH: "search",
  CONTACT: "contact",
  ACCOUNT: "account",
} as const;

export type PageType = (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES];

export const VALID_PAGE_TYPES: readonly string[] = Object.values(PAGE_TYPES);
